import { typeColor } from './map.js';

/** Escape text for safe insertion into HTML. */
function esc(value) {
  return (value ?? '')
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Build a Google Maps directions deep link for turn-by-turn navigation to a place.
 * @param {import('./data.js').Place} place
 */
export function googleMapsNavUrl(place) {
  const destination = `${place.lat},${place.lng}`;
  const params = new URLSearchParams({ api: '1', destination });
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

/**
 * Render the popup HTML for a place.
 * @param {import('./data.js').Place} place
 * @returns {string}
 */
export function renderPopup(place) {
  const parts = [];

  parts.push(`<div class="popup">`);
  parts.push(`<h2 class="popup__name">${esc(place.name)}</h2>`);

  parts.push(`<div class="popup__tags">`);
  for (const label of place.typeLabels) {
    const color = typeColor(label.toLowerCase());
    parts.push(
      `<span class="popup__badge" style="background:${color}">${esc(label)}</span>`,
    );
  }
  parts.push(`<span class="popup__suburb">${esc(place.suburb)}</span>`);
  if (place.priceRange) {
    parts.push(`<span class="popup__price">${esc(place.priceRange)}</span>`);
  }
  if (place.rating) {
    parts.push(`<span class="popup__rating">★ ${esc(place.rating)}</span>`);
  }
  parts.push(`</div>`);

  if (place.imageUrl) {
    parts.push(
      `<img class="popup__image" src="${esc(place.imageUrl)}" alt="${esc(place.name)}" loading="lazy" />`,
    );
  }

  if (place.description) {
    parts.push(`<p class="popup__desc">${esc(place.description)}</p>`);
  }

  if (place.address) {
    parts.push(`<p class="popup__address">${esc(place.address)}</p>`);
  }

  if (place.website) {
    parts.push(
      `<a class="popup__website" href="${esc(place.website)}" target="_blank" rel="noopener noreferrer">Website</a>`,
    );
  }

  parts.push(
    `<a class="popup__nav" href="${esc(googleMapsNavUrl(place))}" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>`,
  );

  parts.push(`</div>`);
  return parts.join('');
}
